/** @format */

import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'src/ui/library/Button';
import GetAppSharpIcon from '@material-ui/icons/GetAppSharp';
import HistoryDisplayContainer from 'src/ui/library/HistoryDisplay';
import intl from 'react-intl-universal';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import { DOC_UPLOAD_NEW_URL, DOC_REQUEST_NEW_URL } from 'src/constants/constants.js';

function DocumentsHeader(props) {
  const { isCase, history, caseManagerId, clientId, caseClosed, docsTableData, getZipDocuments, isLoading } = props;
  const params = `${caseManagerId}/${clientId}`;

  return (
    <React.Fragment>
      {isLoading && <ServiceSpinner open={isLoading} />}
      <div className="documents-button-header">
        {isCase && <h2>{intl.get('documents.headers.caseDocuments')}</h2>}
        <div className="button-container">
          <HistoryDisplayContainer history={history} />
        </div>
        {isCase && (
          <div onClick={() => getZipDocuments(caseManagerId)} className="zip-documents" title="Click here to generate the Zip Documents">
            <GetAppSharpIcon className="file-icon" fontSize="small" />
            {'Zip All Documents'}
          </div>
        )}
        {!caseClosed && (
          <div className={docsTableData.showRequestDocument ? 'link-button-container' : 'link-button-container2'}>
            <Link to={`${DOC_UPLOAD_NEW_URL}/${caseManagerId ? params : ''}`} className="link-button">
              <Button styleType="cmsUpload">
                <span>{intl.get('documents.documentUpload.uploadButton')}</span>
              </Button>
            </Link>
            {docsTableData.showRequestDocument && (
              <Link to={`${DOC_REQUEST_NEW_URL}/${caseManagerId ? params : ''}`} className="link-button">
                <Button styleType="cmsUpload">
                  <span>{intl.get('documents.documentUpload.requestDocuments')}</span>
                </Button>
              </Link>
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default DocumentsHeader;
